export type ChatMessagesView = 'error' | 'loading' | 'messages' | 'empty';

export const chatMessagesView = ({
  loading,
  error,
  count,
}: {
  loading: boolean;
  error: Error | null;
  count: number;
}): ChatMessagesView =>
  error ? 'error' : loading ? 'loading' : count ? 'messages' : 'empty';
